export default "__VITE_ASSET__9768871f__"